import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

/** POST /user/password-reset-request's body and response. Local until @lio/api-types includes them. */
export type PasswordResetRequestBody = {
  email: string;
  recaptchaToken?: string;
};
export type PasswordResetResponse = {
  /** True when Okta can reset this address; false when there's no account (the API emails them). */
  hasAccount: boolean;
};

/** Long enough for the API's reCAPTCHA check and lookup; after that, the reset is left to Okta. */
const PASSWORD_RESET_CHECK_TIMEOUT_MS = 8_000;

/** Asks the API whether an address has an account before Okta's password reset. Needs no token. */
export const useRequestPasswordReset = () => {
  const client = useClient();
  const result = useMutation({
    mutationFn: (requestBody: PasswordResetRequestBody) =>
      client
        .post('user/password-reset-request', { json: requestBody, timeout: PASSWORD_RESET_CHECK_TIMEOUT_MS })
        .json<PasswordResetResponse>(),
  });
  return { ...result, requestPasswordReset: result.mutateAsync };
};
